import { makeStyles, TableCell, TableRow } from "@material-ui/core";
import { useHistory } from "react-router-dom";

export const useStyles = makeStyles((theme) => ({
  rowCell: {
    cursor: "pointer !important",
    background: theme.palette.primary.blue,
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
  rowCellOdd: {
    cursor: "pointer !important",
    background: "white",
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
}));

export default function ClientTableCell({ columns, element, index }) {
  const classes = useStyles();
  const history = useHistory();

  const elementValue = element;
  elementValue.dateCreated = new Date(element.dateCreated).toLocaleDateString("en-US");

  return (
    <TableRow
      className={index % 2 ? classes.rowCell : classes.rowCellOdd}
      key={index}
      onClick={() =>
        history.push({
          pathname: "/baseclientmanagement/baseclientdetails",
          state: elementValue,
        })
      }
      to={{
        pathname: "/baseclientmanagement/baseclientdetails",
        state: elementValue,
      }}
      data-test="base-client-table-row"
    >
      {columns.map((column, elementIndex) => (
        <TableCell align="left" key={elementIndex}>
          {elementValue[column.propName]}
        </TableCell>
      ))}
    </TableRow>
  );
}
